import React, { useState, useEffect } from "react";

import { Button as AntButton, Col, Form, Row, Tooltip, Typography, Radio, message, Space } from "antd";

import { useFieldArray, useForm, useWatch } from "react-hook-form";

import axios from "axios";

import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import { useParams } from "react-router";

import { PlusOutlined } from "@ant-design/icons";
import { defaultRule, torRulesTypeOption } from "../../utils";
import { InputField, InputRadio } from "../../../../atoms/FormElement";
import { changeFieldFormatter, changeFieldParser } from "../utils";
import { DeleteIcon } from "../../../../../assets/svg";
import { apiV1Endpoint } from "../../../../../api/v1";
import { getBookingDetail } from "../../ducks/actions";
import Button from "../../../../molecules/Button";

export default (props) => {
  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      torRules: [defaultRule],
    },
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "torRules",
  });
  // redux states
  const { bookingDetails } = useSelector((state: any) => state.newBooking);

  const { leaseId = bookingDetails.leaseId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch: any = useDispatch();
  const [torCondition, setTorCondition] = useState("or");

  const torRulesValues = useWatch({
    control,
    name: "torRules", //  tells react-hook-form: watch the whole array torRules
  });

  const onSubmit = async (data: any, type) => {
    let torRules = data || getValues();
    props?.setTorRules && props?.setTorRules(torRules);
    const finalTorRules = torRules.torRules.map(({ torRuleCondition, ...rest }) => rest);

    try {
      setIsLoading(true);
      const response = await axios.post(`${apiV1Endpoint}/booking/leaseTorRules`, {
        leaseId: leaseId,
        // just for support to backend logic
        torRuleCondition: torCondition,
        torRules: finalTorRules,
      });

      if (response?.data?.code === 201) {
        setIsLoading(false);
        message.success("TOR rules submitted successfully!");
        await dispatch(getBookingDetail(leaseId));
      }

      props.onClose && props.onClose();
    } catch (error) {
      setIsLoading(false);
      console.error("Error posting TOR rules:", error);
      message.error("Failed to submit TOR rules, please try again.");
    }
  };

  useEffect(() => {
    if (bookingDetails?.torRules && bookingDetails?.torRules?.length > 0) {
      replace(bookingDetails?.torRules || [defaultRule]);
    }
  }, [bookingDetails?.torRules]);

  // ✅ custom remove function
  const removeRule = (index: number) => {
    if (fields.length > 1) {
      remove(index);
    }
  };

  // ✅ custom add function
  const addRule = (newRule) => {
    append(newRule); // ✅ now it's the correct object type
  };

  const { Text } = Typography;

  return (
    <Form layout="vertical" name="bookingform" scrollToFirstError className="bf-main" onFinish={handleSubmit(onSubmit)}>
      {
        <Row gutter={24} style={{ marginTop: "30px" }}>
          <Col span={24}>
            <AntButton
              type="dashed"
              disabled={fields?.length >= 5}
              htmlType="button"
              icon={<PlusOutlined />}
              block={true}
              onClick={() => addRule(defaultRule)}
            >
              <Text className="ag-primary fontWeight600" style={{ fontSize: "14px" }}>
                Add Another Rule
              </Text>
            </AntButton>
          </Col>
        </Row>
      }

      <Row style={{ marginTop: "30px" }}>
        <Col span={24}>
          <InputRadio
            disabled={false}
            control={control}
            fieldname="torRuleCondition"
            initValue={bookingDetails?.torRuleCondition || "or"}
            label="Select TOR Policy"
            onChange={(e: any) => setTorCondition(e?.target?.value)}
            options={
              <Row gutter={[16, 24]}>
                {torRulesTypeOption.map((option, i) => (
                  <Col span={8} key={`${option.value}-${i}`}>
                    <Radio value={option.value}>{option.label}</Radio>
                  </Col>
                ))}
              </Row>
            }
          />
        </Col>
      </Row>
      {fields.map((field, index) => (
        <Row key={field.id} gutter={[6, 12]}>
          <Col span={4}>
            <InputField
              isRequired={true}
              fieldname={`torRules[${index}].torPercent`}
              label="TOR %"
              control={control}
              iProps={{
                type: "number",
                placeholder: "TOR %",
                min: 0,
                max: 100,
                parser: (value: any) => changeFieldParser(value, "amount"),
                formatter: (value: string): any => changeFieldFormatter(value, "amount"),
              }}
              rules={{ required: "TOR % is required" }}
              validate={
                Object.entries(errors).length > 0 &&
                errors?.torRules?.length > 0 &&
                errors?.torRules[index]?.torPercent &&
                "error"
              }
              validMessage={
                Object.entries(errors).length > 0 &&
                errors?.torRules?.length > 0 &&
                errors?.torRules[index]?.torPercent &&
                errors?.torRules[index]?.torPercent?.message
              }
            />
          </Col>
          <Col span={5}>
            <InputField
              isRequired={true}
              fieldname={`torRules[${index}].minSale`}
              label="Min Sale"
              control={control}
              iProps={{
                type: "number",
                placeholder: "Min Sale",
                min: 0,
                parser: (value: any) => changeFieldParser(value, "amount"),
                formatter: (value: string): any => changeFieldFormatter(value, "amount"),
              }}
              rules={{ required: "Min Sale is required" }}
              validate={
                Object.entries(errors).length > 0 &&
                errors?.torRules?.length > 0 &&
                errors?.torRules[index]?.minSale &&
                "error"
              }
              validMessage={
                Object.entries(errors).length > 0 &&
                errors?.torRules?.length > 0 &&
                errors?.torRules[index]?.minSale &&
                errors?.torRules[index]?.minSale?.message
              }
            />
          </Col>
          <Col span={5}>
            <InputField
              isRequired={true}
              fieldname={`torRules[${index}].maxSale`}
              label="Max Sale"
              control={control}
              iProps={{
                placeholder: "Max Sale",
                type: "number",
                min: torRulesValues?.[index]?.minSale || 0,
                parser: (value: any) => changeFieldParser(value, "amount"),
                formatter: (value: string): any => changeFieldFormatter(value, "amount"),
              }}
              rules={{
                required: "Max Sale is required",
                min: {
                  value: torRulesValues?.[index]?.minSale || 0,
                  message: `Min Sale must be greater than or equal to ${torRulesValues?.[index]?.minSale}`,
                },
              }}
              validate={
                Object.entries(errors).length > 0 &&
                errors?.torRules?.length > 0 &&
                errors?.torRules[index]?.maxSale &&
                "error"
              }
              validMessage={
                Object.entries(errors).length > 0 &&
                errors?.torRules?.length > 0 &&
                errors?.torRules[index]?.maxSale &&
                errors?.torRules[index]?.maxSale?.message
              }
            />
          </Col>

          <Col span={4}>
            <InputField
              isRequired={true}
              fieldname={`torRules[${index}].minLimit`}
              label="Min Limit"
              control={control}
              iProps={{
                placeholder: "Min Limit",
                type: "number",
                min: 0,
                parser: (value: any) => changeFieldParser(value, "amount"),
                formatter: (value: string): any => changeFieldFormatter(value, "amount"),
              }}
              rules={{ required: "Min limit is required" }}
              validate={
                Object.entries(errors).length > 0 &&
                errors?.torRules?.length > 0 &&
                errors?.torRules[index]?.minLimit &&
                "error"
              }
              validMessage={
                Object.entries(errors).length > 0 &&
                errors?.torRules?.length > 0 &&
                errors?.torRules[index]?.minLimit &&
                errors?.torRules[index]?.minLimit?.message
              }
            />
          </Col>
          <Col span={5}>
            <InputField
              isRequired={true}
              fieldname={`torRules[${index}].uptoLimit`}
              label="Upto Limit"
              control={control}
              iProps={{
                placeholder: "Upto Limit",
                type: "number",
                min: 1,
                parser: (value: any) => changeFieldParser(value, "amount"),
                formatter: (value: string): any => changeFieldFormatter(value, "amount"),
              }}
              rules={{ required: "Upto limit is required" }}
              validate={
                Object.entries(errors).length > 0 &&
                errors?.torRules?.length > 0 &&
                errors?.torRules[index]?.uptoLimit &&
                "error"
              }
              validMessage={
                Object.entries(errors).length > 0 &&
                errors?.torRules?.length > 0 &&
                errors?.torRules[index]?.uptoLimit &&
                errors?.torRules[index]?.uptoLimit?.message
              }
            />
          </Col>

          {/* <Col span={4}>
            <ReactSelectField
              control={control}
              isRequired={false}
              setValue={setValue}
              initValue={{ ...torRulesTypeOption[0] }} // 👈 cloned
              label="Rule Type"
              fieldname={`torRuleCondition`}
              selectOption={torRulesTypeOption}
              valueGot={
                bookingDetails?.torRules && bookingDetails?.torRules[index]?.torRuleCondition
                  ? torRulesTypeOption?.find((a) => a?.value === bookingDetails?.torRules[index]?.torRuleCondition)
                  : ""
              }
              onChange={(e) => setTorCondition(e?.value)}
              iProps={{ placeholder: "Select", isDisabled: index > 0 ? true : false }}
            />
          </Col> */}
          <Col span={1} style={{ marginTop: "30px" }}>
            <Tooltip title="Delete" trigger="hover" showArrow={false}>
              <AntButton
                type="link"
                disabled={fields?.length == 1}
                style={{ padding: "0px" }}
                onClick={() => removeRule(index)}
              >
                <DeleteIcon />
              </AntButton>
            </Tooltip>
          </Col>
        </Row>
      ))}

      {!props?.parentState ? (
        <Row gutter={24} justify="space-between" style={{ marginTop: "10px" }}>
          <Col>
            <AntButton size="large" onClick={props.onClose}>
              Back
            </AntButton>
          </Col>
          <Col>
            <AntButton
              // label={props?.topButton?.label || "Save"}
              className="ef-approve-btn"
              htmlType="submit"
              disabled={isLoading}
              // onClick={() => }
            >
              {isLoading ? "Loading..." : "Save"}
            </AntButton>
          </Col>
        </Row>
      ) : (
        <Row gutter={24} className="footer">
          <Space size="middle">
            <Button
              label="Cancel"
              className="bf-discard-button"
              onClick={() => props.parentState({ modalPayload: { open: false } })}
            />

            <Button type="submit" label={isLoading ? "Loading..." : "Save"} className="cc-fotter_next-button" />
          </Space>
        </Row>
      )}
    </Form>
  );
};
